import { HomePageWidgets } from '../home-page-widgets';
import { HomePageWidgetConfig } from './home-page-base-widget-config';

export const PipelineWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.Pipeline,
  description: 'shell.homepage.widgets.pipeline.description',
  letter: 'shell.homepage.widgets.pipeline.letter',
  link: '/pipeline',
  linkTitle: 'shell.homepage.widgets.pipeline.linkTitle',
  title: 'shell.homepage.widgets.pipeline.title',
};

export const BiWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.SelfaiBi,
  description: 'shell.homepage.widgets.kd.description',
  letter: 'shell.homepage.widgets.kd.letter',
  link: '/kd',
  linkTitle: 'shell.homepage.widgets.kd.linkTitle',
  title: 'shell.homepage.widgets.kd.title',
};

export const AggregatorsWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.Aggregation,
  description: 'shell.homepage.widgets.aggregation.description',
  letter: 'shell.homepage.widgets.aggregation.letter',
  link: '/pipeline/workflow/5bf5aeec-53bf-45dd-ae11-66ce847c9796',
  linkTitle: 'shell.homepage.widgets.aggregation.linkTitle',
  title: 'shell.homepage.widgets.aggregation.title',
};


export const QuickPrototypesWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.QuickPrototypes,
  description: 'shell.homepage.widgets.quick-prototypes.description',
  letter: 'shell.homepage.widgets.quick-prototypes.letter',
  link: '/pipeline/workflow/b77fe45e-ca01-4f72-a6f4-e414268c3ef5',
  linkTitle: 'shell.homepage.widgets.quick-prototypes.linkTitle',
  title: 'shell.homepage.widgets.quick-prototypes.title',
};

export const InterpretableModelsWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.InterpretableModels,
  description: 'shell.homepage.widgets.interpretable-models.description',
  letter: 'shell.homepage.widgets.interpretable-models.letter',
  link: '/pipeline/workflow/af8ecc4a-8cc8-4cdd-a1c3-1dd14dcc1cf9',
  linkTitle: 'shell.homepage.widgets.interpretable-models.linkTitle',
  title: 'shell.homepage.widgets.interpretable-models.title',
};

export const HighPerfomanceModelsWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.HighPerformanceModels,
  description: 'shell.homepage.widgets.high-perfomance-models.description',
  letter: 'shell.homepage.widgets.high-perfomance-models.letter',
  link: 'https://pipeline.ml-demo.ks-dev.cognive.com/pipeline/workflow/5e3eb081-4c51-4f9e-a1bd-a456a301431d',
  linkTitle: 'shell.homepage.widgets.high-perfomance-models.linkTitle',
  title: 'shell.homepage.widgets.high-perfomance-models.title',
  isExternal: true,
};

export const LLMAgentsWidgetConfig: HomePageWidgetConfig = {
  name: HomePageWidgets.LLMAgents,
  description: 'shell.homepage.widgets.llm-agents.description',
  letter: 'shell.homepage.widgets.llm-agents.letter',
  link: '/pipeline/workflow/e22f4925-0468-42fb-bac2-221a493a3123',
  linkTitle: 'shell.homepage.widgets.llm-agents.linkTitle',
  title: 'shell.homepage.widgets.llm-agents.title',
};

const allwidgets = {
  [HomePageWidgets.Pipeline]: PipelineWidgetConfig,
  [HomePageWidgets.SelfaiBi]: BiWidgetConfig,
  [HomePageWidgets.Aggregation]: AggregatorsWidgetConfig,
  [HomePageWidgets.QuickPrototypes]: QuickPrototypesWidgetConfig,
  [HomePageWidgets.InterpretableModels]: InterpretableModelsWidgetConfig,
  [HomePageWidgets.HighPerformanceModels]: HighPerfomanceModelsWidgetConfig,
  [HomePageWidgets.LLMAgents]: LLMAgentsWidgetConfig,
};

export function getStartPageWidgetsConfigs(widgetNames: HomePageWidgets[]) {
  return widgetNames.map((wName) => allwidgets[wName]);
}
